import { SubButton } from '@/common/buttons/SubButton';
import { EntityDetail } from '@/common/entityFramework/entityDetail/EntityDetail';
import { EntityForm } from '@/common/entityFramework/entityForm/EntityForm';
import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext';
import { ValList } from '@/common/val/ValList';
import { AbvChannelSummaryList } from './AbvChannelSummaryList';
import { AbvLbeItemList } from './AbvLbeItemList';

export const AbvLbeDetail = () => {

  const { entityObj } = useEntityMgr();

  const tabSpecs = [
    { id: 'infoTab', label: 'Info', content: <EntityForm /> },
    { id: 'lbeItemTab', label: 'LBE Items', content: <AbvLbeItemList lbeId={entityObj.id}/> },
    { id: 'channelSummaryTab', label: 'Channel Summary', content: <AbvChannelSummaryList lbeId={entityObj.id}/> },
    { id: 'valTab', label: 'Validations', content: <ValList parentEntity="LBE" parentEntityId={entityObj.id} />}
  ];

  const augButtons = (buttons) => {
      buttons.push(<SubButton key="subButton"/>);
  }

  return (
    <EntityDetail tabSpecs={tabSpecs} augButtons={augButtons} />
  );
}